import React from 'react';

import { roundToDecimals } from '../../../../utils/helpers';

const CardNumber = ({ value, loading, classes, ...rest }) => {
  if ((!value && loading) || value === null) return null;
  if (!value) {
    return <div className={classes.cardNumber}>0</div>;
  }

  let rounded;
  let values;
  let integer;
  let decimal;
  const valueIsNumber = !isNaN(value);

  if (valueIsNumber) {
    rounded = value && roundToDecimals(value);
    values = rounded && `${rounded}`.split('.');
    integer = values && values[0];
    decimal = values && values[1];
  }

  return (
    <div data-testid={rest['data-testid']} className={classes.cardNumber}>
      {valueIsNumber ? (
        <>
          {integer || 0}
          {decimal ? <span className={classes.decimal}>.{decimal}</span> : ''}
        </>
      ) : (
        <>{value()}</>
      )}
    </div>
  );
};

export default CardNumber;
